export const GAME_CHECK_DEF_HIT = {
    checkInner: ({ armorType }) => {
        for (const point in armorType) {
            const { uppers } = armorType[point];
            if (uppers && uppers.find(x => x.type === 'deflect' && x.hp > 0)) return false;
        }
        return true;
    }
}